module.exports = __webpack_public_path__ + "static/media/ntt.bdd72f63.jpg";